<template>
  <el-dialog append-to-body width="500px" :title="title" center="" :visible.sync="visible" :before-close="handleClose">
    <div class="modal-body">
      <div class="payModal">
        <p>{{ pay.body || '订单支付' }}</p>
        <p>{{ formatPrice(pay.price || 0) }}</p>
        <img class="payCodeImg" :src="pay.qrcode_url" alt="" />
      </div>
      <div class="refresh">
        <span>请打开手机{{ pay.payment_type == 1 ? '微信扫码' : '支付宝扫一扫' }}支付</span>
        <!-- <span @click="getPayQrcode">点击刷新二维码</span> -->
      </div>
    </div>
  </el-dialog>
</template>

<script>
import { getPayDetail, getPayQrcode } from "@/api/pay";
import { v4 as uuidv4 } from 'uuid';
import waves from '@/directive/waves' // 水波纹指令
export default {
  name: 'PayQrcode',
  directives: {
    waves
  },
  props: {
    visible: {
      type: Boolean,
      required: true
    },
    title: {
      type: String,
      default: '在线支付'
    },
    pay: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      loading: false,
      timer: null
    }
  },
  watch: {
    visible(value) {
      if (value) {
        clearInterval(this.timer)
        this.timer = setInterval(() => {
          this.getPayDetail()
        }, 1000)
      }
    }
  },
  created() {
    this.formatPrice = this.utils.formatPrice
  },
  methods: {
    getPayQrcode() {
      getPayQrcode({ pay_no: this.payNo, uuid: uuidv4() }).then((res) => {
        this.pay.qrcode_url = res.data
      }).catch((err) => {

      })
    },
    getPayDetail() {
      getPayDetail({ id: this.pay.id }).then((res) => {
        if (res.data.status == 1) {
          console.log('已支付！')
          clearInterval(this.timer)
          this.$message.success('支付成功，正在为您跳转。。。'), setTimeout(() => {
            this.$emit('success', true)
            this.handleClose()
          }, 1000);
        } else {
          console.log('未支付！')
        }
      }).catch((err) => {

      })
    },
    // 关闭窗口
    handleClose() {
      clearInterval(this.timer)
      // 更新visible参数
      this.$emit('update:visible', false)
    }
  }
}
</script>
<style lang="scss" scoped>
.modal-body {
  display: flex;
  align-items: center;
  flex-direction: column;
  row-gap: 30px;
  padding-top: 10px;
  padding-bottom: 40px;

  .payModal {
    display: flex;
    align-items: center;
    flex-direction: column;
    font-weight: 400;
    font-style: normal;
    font-size: 23px;
    row-gap: 20px;
    line-height: 35px;
    text-align: center;
    padding: 0 20px;

    .payCodeImg {
      width: 275px;
      height: 275px;
    }
  }

  .refresh {
    font-size: 20px;
    font-weight: 400;
    color: #222222;
    cursor: pointer;
  }
}
</style>
